// Atonradiustable.jsx
import React from "react";

const fmt = (n, d = 0) => (Number.isFinite(n) ? n.toFixed(d) : "");

export default function AtonRadiusTable({
  atons = [],           // [{ id, name, lat, lng, distance_m }]
  totalCount,
  height = 320,
  onRowDoubleClick,     // (row) => void
}) {
  return (
    <div>
      <div style={{ fontWeight: 700, marginBottom: 8 }}>검색 목록</div>

      <div style={{ border: "1px solid #e5e7eb", borderRadius: 8, overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "separate", borderSpacing: 0 }}>
          <thead style={{ background: "#f9fafb" }}>
            <tr>
              <th style={{ padding: "8px 10px", textAlign: "left", borderBottom: "1px solid #e5e7eb" }}>이름</th>
              <th style={{ padding: "8px 10px", textAlign: "right", borderBottom: "1px solid #e5e7eb", width: 120 }}>
                거리(m)
              </th>
            </tr>
          </thead>
        </table>

        <div style={{ maxHeight: height, overflow: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "separate", borderSpacing: 0 }}>
            <tbody>
              {atons.map((a) => {
                const id = String(a.id);
                return (
                  <tr
                    key={id}
                    style={{ borderBottom: "1px solid #f1f5f9", cursor: "pointer" }}
                    onDoubleClick={() => onRowDoubleClick?.(a)}
                    title="더블클릭하면 지도에서 위치로 이동"
                  >
                    <td style={{ padding: "8px 10px" }}>
                      {a.name || a.name_ko || a.name_en || "표지"}
                    </td>
                    <td style={{ padding: "8px 10px", textAlign: "right", fontVariantNumeric: "tabular-nums" }}>
                      {fmt(a.distance_m, 0)}
                    </td>
                  </tr>
                );
              })}

              {atons.length === 0 && (
                <tr>
                  <td colSpan={2} style={{ padding: 16, color: "#6b7280", textAlign: "center" }}>
                    검색 결과가 없습니다.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div style={{ marginTop: 8, fontSize: 12, color: "#6b7280" }}>
        검색: {atons.length} / {totalCount}
      </div>
    </div>
  );
}
